import {
    GET_PDF_LAMBDA,
    OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER,
    SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE,
} from "../Actions/Types";
import { DialogTrainingState } from "../Enums/DialogTrainingState";

export interface IDigitalShareReducer {
  dialogTrainingState: DialogTrainingState;
  isChoosingDigitalShare: boolean;
  isPdfLambdaCreating: boolean;
}

export const defaultState: IDigitalShareReducer = {
    dialogTrainingState: DialogTrainingState.LoopNet,
    isChoosingDigitalShare: false,
    isPdfLambdaCreating: false,
};

export const digitalShare = (
    state: IDigitalShareReducer = { ...defaultState },
    action
): IDigitalShareReducer => {
    switch (action.type) {
    /** misc */
        case SET_DIGITAL_SHARE_DIALOG_TRAINING_STATE: {
            return {
                ...state,
                dialogTrainingState: action.data as DialogTrainingState,
            };
        }

        case OPEN_DIGITAL_SHARE_DIALOGUE_FROM_WRAPPER: {
            return {
                ...state,
                isChoosingDigitalShare: action.data as boolean,
            };
        }

        case GET_PDF_LAMBDA: {
            return {
                ...state,
                isPdfLambdaCreating: true,
            };
        }
        default:
            return state;
    }
};
